<template>
    <FormBox header="Medientyp &amp; Schlagworte">
        <div class="row" style="--bs-gutter-x:60px;">
            <!-- Media Types -->
            <div class="col-12 col-lg-6">
                <RepeatableField
                    :model-value="form.mediaTypes"
                    @update:model-value="form.mediaTypes = $event"
                    :max-items="20"
                    :create-empty="() => null"
                >
                    <template #default="{ index, isFirst }">
                        <FormSelect
                            :model-value="form.mediaTypes[index]"
                            @update:model-value="updateArrayItem(form.mediaTypes, index, $event)"
                            :options="payload.mediaTypes"
                            option-value="uid"
                            option-label="name"
                            label="Medientyp"
                            :tooltip="isFirst ? 'mediaTypes' : ''"
                            placeholder="Medientyp auswählen"
                            :required="isFirst"
                            :no-margin="true"
                        />
                    </template>
                </RepeatableField>
            </div>

            <!-- Keywords -->
            <div class="col-12 col-lg-6">
                <RepeatableField
                    :model-value="form.keywords"
                    @update:model-value="form.keywords = $event"
                    :max-items="50"
                    :create-empty="() => null"
                >
                    <template #default="{ index, isFirst }">
                        <FormSelect
                            :model-value="keywordValue(index)"
                            @update:model-value="updateKeyword(index, $event)"
                            :options="keywordOptions(index)"
                            option-value="uid"
                            option-label="name"
                            label="Schlagwort"
                            :tooltip="isFirst ? 'keywords' : ''"
                            placeholder="Schlagwort auswählen"
                            :required="isFirst"
                            :no-margin="true"
                            :can-create="true"
                            :ajax-url="keywordSearchUrl"
                        />
                    </template>
                </RepeatableField>
            </div>
        </div>
    </FormBox>
</template>

<script setup>
import FormBox from './FormBox.vue';
import FormSelect from './FormSelect.vue';
import RepeatableField from './RepeatableField.vue';

const props = defineProps({
    form: { type: Object, required: true },
    payload: { type: Object, required: true },
    keywordSearchUrl: { type: String, default: '/api/keywords' },
});

function updateArrayItem(arr, index, value) {
    arr[index] = value;
}

/**
 * Keywords in form state can be:
 *   - number (UID of existing keyword)
 *   - string (name of new keyword to create)
 *   - { uid, name } object (from initial edit data)
 *   - null (empty slot)
 *
 * The FormSelect component expects a UID (number) or string (create).
 */
function keywordValue(index) {
    const kw = props.form.keywords[index];
    if (kw === null || kw === undefined) return null;
    if (typeof kw === 'object' && kw.uid) return kw.uid;
    return kw; // number or string
}

function updateKeyword(index, value) {
    props.form.keywords[index] = value;
}

/**
 * For the keyword select, show existing keywords from the publication as static options.
 * AJAX will provide the full searchable list.
 */
function keywordOptions(index) {
    // Provide current keywords as static options so the selected value can show its label
    return props.form.keywords
        .filter(kw => kw !== null && typeof kw === 'object' && kw.uid)
        .map(kw => ({ uid: kw.uid, name: kw.name }));
}
</script>
